const handleProductTitle = () => {
  const pDetailInnerHeader = document.querySelector(".p-detail-inner-header");
  const starsWrapper = document.querySelector(".stars-wrapper");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!pDetailInnerHeader || !pInfoWrapper) return;
  pInfoWrapper.prepend(pDetailInnerHeader);
  if (starsWrapper) pDetailInnerHeader.after(starsWrapper);
};

const handleProductTopFlags = () => {
  const productFlags = document.querySelector(".p-detail-info .flags-default");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!productFlags || !pInfoWrapper) return;
  pInfoWrapper.prepend(productFlags);
};

const handleAddToCartBlock = () => {
  const addToCartBlock = document.createElement("div");
  addToCartBlock.classList.add("add-to-cart-block");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!pInfoWrapper) return;
  pInfoWrapper.append(addToCartBlock);

  const pFinalPriceWrapper = document.querySelector(".p-final-price-wrapper");
  if (pFinalPriceWrapper) addToCartBlock.append(pFinalPriceWrapper);

  const pQuantity = document.querySelector(".quantity");
  if (pQuantity) addToCartBlock.append(pQuantity);

  const addToCart = document.querySelector(".add-to-cart");
  if (addToCart) addToCartBlock.append(addToCart);

  // jestli jsem dobře pochopil trello
  const giftWrapper = document.querySelector(".p-gifts-wrapper");
  if (giftWrapper) addToCartBlock.append(giftWrapper);
};

const handleProductCode = () => {
  const pCode = document.querySelector(".product-top .p-code");
  const socialButtonsWrapper = document.querySelector(
    ".social-buttons-wrapper .link-icons"
  );
  if (!pCode || !socialButtonsWrapper) return;
  socialButtonsWrapper.prepend(pCode);
};

const handleShareButton = () => {
  const share = document.querySelector(".social-buttons-wrapper .share");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!share || !pInfoWrapper) return;
  const socialButtons = document.querySelector(
    ".social-buttons-wrapper .social-buttons"
  );
  if (!socialButtons) return;
  pInfoWrapper.append(share);
  share.append(socialButtons);
};

const handleProductAvailability = () => {
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!pInfoWrapper) return;
  const availabilityWrapper = document.createElement("div");
  availabilityWrapper.classList.add("availability-wrapper");
  pInfoWrapper.appendChild(availabilityWrapper);
  const deliveryOptions = document
    .querySelector(".shipping-options")
    ?.closest("th");
  const toRemove = deliveryOptions?.closest("tr");
  if (deliveryOptions) availabilityWrapper.append(deliveryOptions);
  if (toRemove) toRemove.remove();

  const availability = document.querySelector(
    ".p-info-wrapper .availability-value"
  );
  const deliveryTimeLabel = document.querySelector(
    ".p-info-wrapper .delivery-time-label"
  );
  if (availability) {
    if (deliveryTimeLabel) {
      deliveryTimeLabel.prepend(availability);
    } else {
      availabilityWrapper.prepend(availability);
    }
  }
};

const handleProductUSP = () => {
  const productUSP = document.querySelector(
    ".benefitBanner.position--benefitProduct"
  );
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!productUSP || !pInfoWrapper) return;
  const uspBlock = document.createElement("div");
  uspBlock.classList.add("usp-block");
  uspBlock.append(productUSP);
  pInfoWrapper.append(uspBlock);
};

const handleVIPBanner = () => {
  const vipBanner = document.querySelector(".vip-banner");
  if (!vipBanner) return;
  const toRemove = vipBanner.closest(".banner").parentElement;
  const whereToAppend =
    document.querySelector(".usp-block") ||
    document.querySelector(".p-info-wrapper");
  if (whereToAppend) {
    whereToAppend.append(vipBanner);
  }
  if (toRemove) toRemove.remove();
};

const handleDetailBanner = () => {
  const detailBanner = document.querySelector(".custom-footer__banner52");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (detailBanner && pInfoWrapper) {
    pInfoWrapper.append(detailBanner);
  } else if (detailBanner) {
    detailBanner.remove();
  }
};

const handleProductGallery = () => {
  const pImage = document.querySelector(".p-image");
  const thumbnails = document.querySelectorAll(".p-thumbnails .p-thumbnail");
  if (!pImage || thumbnails.length === 0) return;
  for (let i = 0; i < thumbnails.length; i++) {
    const thumbnail = thumbnails[i];
    if (i === 0) {
      thumbnail.remove();
      continue;
    }
    pImage.append(thumbnail);
    const thumbnailImg = thumbnail.querySelector("img");
    if (thumbnailImg) {
      thumbnailImg.setAttribute(
        "data-src",
        thumbnailImg.getAttribute("data-src").replace("/related/", "/big/")
      );
      thumbnailImg.src = thumbnailImg.getAttribute("data-src");
      thumbnailImg.removeAttribute("width");
      thumbnailImg.removeAttribute("height");
    }
    thumbnail.classList.remove("p-thumbnail");
    thumbnail.classList.add("p-main-image");
  }
  if (window.innerWidth <= 991) {
    $(pImage).slick({
      slidesToShow: 1.2,
      dots: true,
      arrows: false,
      infinite: false,
    });
  }
};

const handleTabContent = () => {
  if (window.innerWidth <= 991) return;
  const tabContent = document.querySelector("#tab-content");
  const pImageWrapper = document.querySelector(".p-image-wrapper");
  const pDetailInner = document.querySelector(".p-detail-inner");
  if (!tabContent || !pImageWrapper || !pDetailInner) return;
  pImageWrapper.append(tabContent);
  pDetailInner.prepend(pImageWrapper);
};

const handleRelatedProducts = () => {
  const relatedHeading = document.querySelector(".products-related-header");
  if (relatedHeading) relatedHeading.textContent = "Ke kombinování";
  const relatedBlock = document.querySelector(".products-related");
  if (window.innerWidth <= 991) {
    const shpTabsWrapper = document.querySelector(".shp-tabs-wrapper");
    if (relatedBlock && shpTabsWrapper) {
      shpTabsWrapper.parentElement.insertBefore(
        relatedBlock,
        shpTabsWrapper.nextSibling
      );
    }
    if (relatedHeading && shpTabsWrapper) {
      shpTabsWrapper.parentElement.insertBefore(relatedHeading, relatedBlock);
    }
  }
  if (relatedBlock) {
    $(relatedBlock).slick({
      slidesToShow: 5,
      dots: true,
      arrows: true,
      slidesToScroll: 5,
      infinite: false,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 1000, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        {
          breakpoint: 575,
          settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false },
        },
      ],
    });
  }
};

const handleAlternativeProducts = () => {
  const alternativeBlock = document.querySelector("#productsAlternative");
  if (!alternativeBlock) return;
  const alternativeHeading = document.createElement("h2");
  alternativeHeading.classList.add("products-related-header");
  alternativeHeading.textContent = "Podobné produkty";
  alternativeBlock.prepend(alternativeHeading);
  if (window.innerWidth <= 991) {
    const shpTabsWrapper = document.querySelector(".shp-tabs-wrapper");
    if (alternativeBlock && shpTabsWrapper) {
      shpTabsWrapper.parentElement.insertBefore(
        alternativeBlock,
        shpTabsWrapper.nextSibling
      );
    }
  } else {
    const pDetailInner = document.querySelector(".p-detail-inner");
    if (alternativeBlock && pDetailInner) {
      pDetailInner.parentElement.insertBefore(
        alternativeBlock,
        pDetailInner.nextElementSibling
      );
    }
  }
  const toSlick = alternativeBlock.querySelector(".products");
  if (toSlick) {
    $(toSlick).slick({
      slidesToShow: 5,
      dots: true,
      arrows: true,
      slidesToScroll: 5,
      infinite: false,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 1000, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        {
          breakpoint: 575,
          settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false },
        },
      ],
    });
  }
};

const handleProductDescriptionClick = () => {
  const descriptionLink = document.querySelector("p a[href='#description']");
  const description = document.querySelector("#description");

  if (descriptionLink && description) {
    descriptionLink.addEventListener("click", () => {
      description.scrollIntoView(true);
    });
  }
};

const handleVoteWraps = () => {
  document.querySelectorAll(".vote-wrap").forEach((wrap) => {
    if (wrap.closest("#discussionWrapper")) return;

    const voteHeader = wrap.querySelector(".vote-header");
    if (!voteHeader) return;

    const voteSummary = voteHeader.querySelector(".vote-summary");
    if (!voteSummary) return;

    const voteName = voteSummary.querySelector(".vote-name");
    const voteRating = voteSummary.querySelector(".vote-rating");
    const voteTime = voteRating ? voteRating.querySelector(".vote-time") : null;

    if (!voteName || !voteRating) return;

    // Move stars before name in vote-summary (flex-column: stars then name)
    voteSummary.insertBefore(voteRating, voteName);

    // Extract time from rating and put it next to name
    if (voteTime) {
      const authorRow = document.createElement("span");
      authorRow.className = "vote-author-row";
      authorRow.appendChild(voteName);
      authorRow.appendChild(voteTime);
      voteSummary.appendChild(authorRow);
    }
  });
};

const handleProductCards = () => {
  if (!document.body.classList.contains("type-detail")) return;
  const tabContent = document.querySelector("#tab-content");
  if (!tabContent) return;

  const cardSelectors = [
    ".biochem-card",
    ".houba-card",
    ".med-card",
    ".sila-card",
    ".priroda-card",
    ".fakta-card",
  ];

  let insertAfter = tabContent.querySelector(".basic-description") || tabContent.lastElementChild;

  cardSelectors.forEach((selector) => {
    const card = document.querySelector(selector);
    if (!card) return;
    const bannerWrapper = card.closest('[class*="custom-footer__banner"]');
    if (insertAfter) {
      insertAfter.after(card);
      insertAfter = card;
    } else {
      tabContent.append(card);
    }
    if (bannerWrapper) bannerWrapper.remove();
  });
};

const handleMobileProductImage = () => {
  if (window.innerWidth > 767) return;
  const pImageWrapper = document.querySelector(".p-image-wrapper");
  const starsWrapper = document.querySelector(".p-info-wrapper .stars-wrapper");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!pImageWrapper) return;
  if (starsWrapper) {
    starsWrapper.after(pImageWrapper);
  } else if (pInfoWrapper) {
    pInfoWrapper.prepend(pImageWrapper);
  }
};

const handleDenniDavka = () => {
  const denniDavka = document.querySelector(".denni-davka");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  if (!denniDavka || !pInfoWrapper) return;
  pInfoWrapper.append(denniDavka);
};

const handleDetailFavButton = () => {
  const move = () => {
    const favDiv = document.querySelector(".dkLabFavouriteDiv");
    const links = document.querySelector(".link-icons");
    if (!favDiv || !links) return;
    if (links.contains(favDiv)) return;
    links.append(favDiv);
  };

  move();

  const observer = new MutationObserver(move);
  observer.observe(document.body, { childList: true, subtree: true });
};

export {
  handleProductTitle,
  handleProductTopFlags,
  handleAddToCartBlock,
  handleProductCode,
  handleShareButton,
  handleProductAvailability,
  handleProductUSP,
  handleVIPBanner,
  handleDetailBanner,
  handleProductGallery,
  handleTabContent,
  handleRelatedProducts,
  handleAlternativeProducts,
  handleProductDescriptionClick,
  handleProductCards,
  handleVoteWraps,
  handleMobileProductImage,
  handleDetailFavButton,
  handleDenniDavka,
};
